import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

const DEFAULT_NOTICES = [
    {
        id: 'default-1',
        title: 'OFFICIAL GOVERNMENT NOTICE',
        content: 'It is a crime for anyone to refer to the Yoruba Nation without the official designation D.R.Y (Democratic Republic of the Yoruba). The D.R.Y is the only recognized sovereign entity. Any reference to "Yoruba Nation" without D.R.Y is a violation under international law.',
        type: 'urgent', // urgent, info, success
        date: new Date().toISOString(),
        image: null
    }
];

export const getNotices = async () => {
    try {
        const res = await axios.get(`${API_BASE_URL}/notices`);
        const items = Array.isArray(res.data) ? res.data : [];
        if (!items.length) {
            return DEFAULT_NOTICES;
        }
        const notices = items.sort((a, b) => new Date(b.date) - new Date(a.date));
        return notices;
    } catch (err) {
        console.error("Error getting notices:", err);
        return DEFAULT_NOTICES;
    }
};

export const saveNotice = async (notice) => {
    try {
        const newNotice = {
            ...notice,
            date: notice.date || new Date().toISOString()
        };
        if (newNotice.id) {
            await axios.put(`${API_BASE_URL}/notices/${newNotice.id}`, newNotice);
        } else {
            await axios.post(`${API_BASE_URL}/notices`, newNotice);
        }
        const all = await getNotices();
        return all;
    } catch (err) {
        console.error("Error saving notice:", err);
        throw err;
    }
};

export const deleteNotice = async (id) => {
    try {
        await axios.delete(`${API_BASE_URL}/notices/${id}`);
        const all = await getNotices();
        return all;
    } catch (err) {
        console.error("Error deleting notice:", err);
        throw err;
    }
};
